import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

const StyledSponsorCard = withViewportStyle("div")`
  width: 100%;
  margin: 0 ${rem(12)} ${rem(24)} ${rem(12)};

  ${({ $viewport }) => $viewport.mobile`
     margin: 0 ${rem(8)} ${rem(16)} ${rem(8)};
  `};
`;

const CardContainer = styled.div`
  background: #fff;
  border-radius: ${rem(16)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
  padding: ${rem(8)};
`;

const SponsorCardLink = styled.a`
  position: absolute;
  inset: 0;
`;

const Logo = styled.img`
  object-fit: scale-down;
  height: calc(100% - ${rem(32)});
  max-width: 100%;
`;

const StyledText = withViewportStyle("span")<{
  color: string;
}>`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  max-width: 100%;
  font-weight: 600;
  font-size: ${rem(16)};
  line-height: ${rem(32)};
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  color: ${({ color }) => color};

  ${({ $viewport }) => $viewport.mobile`
    display: none;
  `};
`;

export { CardContainer, SponsorCardLink, Logo, StyledSponsorCard, StyledText };
